(function () {
  const root = document.querySelector('[data-atd-pid]');
  if (!root) return;

  root.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger || !root.contains(trigger)) return;

    const item = trigger.closest('[data-accordion-item]');
    const body = item && item.querySelector('[data-accordion-body]');
    if (!body) return;

    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');

    if (expanded) {
      // collapse
      body.dataset.open = 'false';
      // wait for CSS transition
      window.setTimeout(() => { body.hidden = true; }, 240);
    } else {
      // expand
      body.hidden = false;
      // next frame to allow style application
      requestAnimationFrame(() => { body.dataset.open = 'true'; });
    }
  });
})();
